import moment from "moment";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useAuth } from "../../context/userContext";
import AnimatedPage from "../FramerMotion/AnimatedPage";
import PageTitle from "../Misc/PageTitle";
import axiosInstance from "../../config/axiosInstance";

function SingleTransactionRedemption({ baseURL, clientID, AppDisplayName, currency }) {
    const { authUser } = useAuth();

    const { billref } = useParams();

    const [transactionHistory, setTransactionHistory] = useState({});

    const [voucherIssued, setVoucherIssued] = useState("No");

    const [voucherRedeemed, setVoucherRedeemed] = useState({});

    useEffect(() => {
        if (authUser) {
            getCustomerHistoryData(baseURL);
        }
    }, [authUser]);

    const getCustomerHistoryData = async (baseURL) => {
        const payLoad = {
            DIV_DES: "",
            DIV_ID: "1",
            FUNCTION: "GetLoyPoints",
            SEND_KEY: "123456",
            DATA: {
                AUTH_KEY: "TXlDb206TG95QVBJMTIz",
                TYPE_NAME: "CUSTOMER_HISTORY",
                MOBILE_NUM: authUser?.MOBILE ?? "", // Optional chaining for authUser
                FROM_DATE: "2023-01-01",
                TO_DATE: "2024-01-30",
                CLIENT_ID: clientID,
            },
        };
    
        try {
            // Make the API call with the payload
            const response = await axiosInstance.post(`${baseURL}/GetLoyPoints`, payLoad, {
                headers: {
                    "Content-Type": "application/json",
                },
            });
    
            if (response?.data?.STATUS) {
                // Filter data based on billref (Assuming `billref` is defined somewhere)
                const bill = response?.data?.BILL_DETAILS?.filter(item => item?.BILLREF === billref) ?? [];
                const item = response?.data?.ITEM_DETAILS?.filter(item => item?.BILLREF === billref) ?? [];
                const voucherIssued = response?.data?.VOUCHER_ISSUED?.filter(item => item?.BILLREF === billref) ?? [];
                const voucherRedeemed = response?.data?.VOUCHER_REDEEMED?.filter(item => item?.BILLREF === billref) ?? [];
                const pointsEarned = response?.data?.POINTS_EARNED?.filter(item => item?.BILLREF === billref) ?? [];
    
                // Set filtered transaction history
                setTransactionHistory({
                    BILL_DETAILS: bill,
                    ITEM_DETAILS: item,
                    VOUCHER_ISSUED: voucherIssued,
                    VOUCHER_REDEEMED: voucherRedeemed,
                    POINTS_EARNED: pointsEarned,
                });
    
                // Check for issued vouchers
                const issued = voucherIssued ?? [];
                if (issued.length > 0) {
                    setVoucherIssued("Yes");
                }
    
                // Check for redeemed vouchers
                const redeemed = voucherRedeemed ?? [];
                if (redeemed.length > 0) {
                    setVoucherRedeemed(redeemed);
                }
            } else {
                setTransactionHistory([]); // Clear transaction history if response status is not valid
            }
        } catch (error) {
            console.error("Error fetching customer history:", error);
            setTransactionHistory([]); // Clear transaction history on error
        }
    };
    
    return (
        <AnimatedPage>
            <div className="position-sticky z-2 bg-wafaa-white-3 mh-100dvh">
                <PageTitle name="TRANSACTION DETAILS" />

                <div className="w-100 pb-5 bg-wafaa-white-3">
                    <div className=" font-size-13 w-90 mx-auto  shadow p-3 rounded-3 px-3 pb-1 pt-3 mt-3 bg-wafaa-white-2 border border-1 border-wafaa-grey-2">
                        <div className="d-flex justify-content-between ">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">{AppDisplayName ? AppDisplayName : "TRUE VALUE"} ID</p>
                            </div>

                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{transactionHistory && transactionHistory.POINTS_EARNED ? transactionHistory.POINTS_EARNED[0].CUSTOMER_CODE : ""}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between ">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">{AppDisplayName ? AppDisplayName : "True Value"} ID Scan</p>
                            </div>

                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{transactionHistory && transactionHistory.ITEM_DETAILS ? moment(transactionHistory.TRAN_DATE).format("DD MM YYYY, h:m:s a") : ""}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold"> Redeem Date</p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{voucherRedeemed && voucherRedeemed.length ? moment(voucherRedeemed[0].REEDEM_DATE).format("DD MM YYYY, h:m:s a") : ""}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">Value</p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{voucherRedeemed && voucherRedeemed.length ? voucherRedeemed[0].VALUE : ""}</p>
                            </div>
                        </div>
                        <div className="d-flex justify-content-between  border border-1 border-top-0 border-start-0 border-end-0 border-wafaa-grey-2">
                            <div
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-grey fw-semibold">Bill Reference </p>
                            </div>
                            <div
                                className="d-flex justify-content-end"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold">{billref}</p>
                            </div>
                        </div>

                        <div className="d-flex justify-content-between  my-3">
                            <div
                                style={{
                                    width: "50%",
                                    fontSize: "15px",
                                }}
                            >
                                <p className="text-wafaa-dark-blue-2 fw-semibold m-0">Total Paid</p>
                            </div>
                            <div
                                className="d-flex justify-content-end align-items-center"
                                style={{
                                    width: "50%",
                                }}
                            >
                                <p className="text-wafaa-bright-green text-end m-0  fw-semibold">
                                    {transactionHistory && transactionHistory.BILL_DETAILS ? transactionHistory.BILL_DETAILS[0].BILL_AMOUNT : 0} {currency || "AED"}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </AnimatedPage>
    );
}
export default SingleTransactionRedemption;
